import elementExists from "../../../core/utils/element-exists";
import eventBus from "../../../core/services/event-bus";
import ProductJSON from "./product-json";

const ProductDetails = () => {
  let { currentVariant, productData, productVariantMeta , productOptions } = ProductJSON();

  let priceContainer = document.querySelector("[data-regular-price]");
  let currentVariantMeta = null;
  let variantHasCase = false;
  let isClosure = productData.type == "Closure";
  /** Fields for tracking closure quantity */
  const caseCountInput = document.querySelector("[data-count-cases]");
  const itemCountInput = document.querySelector("[data-count-items]");
  const dataQuantityInput = document.querySelector("[data-quantity-input]");

  const itemCountText = document.querySelector("[sh-item-case]");
  const variantPriceText = document.querySelector("[sh-item-price]");

  const btnTrigger = document.querySelector("[product-primary-button]");
  const moqMessage = document.querySelector("[product-closure-moq-message]");
  const shProductForm = document.querySelector("[sh-product-form]");

  const optionTextContainer = document.querySelector("[sh-option-name]");
  const optionPriceText = document.querySelector("[sh-option-price");
  const optionTypeText = document.querySelector("[sh-option-type]");

  /*
   * Update the sku text on variant change
   */
  const updateSku = function () {
    let sku = document.getElementById("product-sku");
    if (elementExists(sku)) {
      sku.innerText = `${currentVariant.sku}`;
    }
  };

  /**
   * Need to refactor this to find out of the item has a case quantity
   * Check for the container before it is being used
   */
  const updateItemPrice = function () {
    if (productData.type == "Item") {
      priceContainer.innerText = Shopify.formatMoney(
        currentVariant.price * currentVariantMeta.case_quantity
      );
    }
  };
  /**
   * Update the price per piece text if the item is a closure
   */
  const updateClosurePrice = function () {
    if (productData.type == "Closure") {
      const casePiecesText = document.querySelector("[sh-case-pieces]");
      if (casePiecesText) {
        const packPosition = productOptions.findIndex( option => option.name == 'Pack');
        const pack = currentVariant.options[packPosition];
        if (pack == "Case" ) {
          const span = casePiecesText.querySelectorAll("span")[0];
          span.textContent = Shopify.formatMoney(currentVariant.price);
          casePiecesText.classList.remove("d-none");
        } else {
          casePiecesText.classList.add("d-none");
        }
      }
    }
  };

  /**
   * The produt variant meta is an object with the variant id as the key
   */
  const getCurrentVariantMeta = function () {
    if (productVariantMeta) {
      if (productVariantMeta.hasOwnProperty(currentVariant.id)) {
        currentVariantMeta = productVariantMeta[currentVariant.id];
        variantHasCase = currentVariantMeta.case_quantity > 0;
      }
    }
  };
  /**
   * Update the variant price text based on the case quantity
   * @param {*} product
   */
  const updateVariantText = () => {
    if (elementExists(variantPriceText)) {
      variantPriceText.innerText = Shopify.formatMoney(currentVariant.price);
    }
    if (elementExists(itemCountText)) {
      if (currentVariantMeta.case_quantity > 0) {
        itemCountText.innerText =
          currentVariantMeta.case_quantity +
          (productData.type == "Item" ? " items" : " pieces") +
          " / case";
      } else {
        itemCountText.innerText = "";
      }
    }
  };

  /**
   * Update the total items per case if there is a case quantity
   */
  const updateTotalItems = () => {
    if ( !elementExists(caseCountInput) && !elementExists(itemCountInput) ) {
      console.warn('product-details: no iput fields found');
      return false;
    }

    let totalItems = caseCountInput.value;
    let caseCount = caseCountInput.value;

    if ( variantHasCase ) {
      totalItems = caseCount * currentVariantMeta.case_quantity;
    }

    itemCountInput.value = totalItems;
    updateSubtotal()
  };

  /**
   * Update the subtotal
   * Check if the variant has a case quantity
   * @returns {void}
   */
  const updateSubtotal = () => {
    const quantity = caseCountInput.value;
    const price = currentVariant.price;
    let subtotal = quantity * price;
    if( currentVariantMeta.case_quantity > 0 ) {
      subtotal = subtotal * currentVariantMeta.case_quantity;
    }

    priceContainer.innerText = Shopify.formatMoney(subtotal);
  };

  /**
   * Toggle the minimum order quantity message
   */
  const toggleMoq = function () {
    if (
      elementExists(moqMessage) &&
      elementExists(btnTrigger) &&
      elementExists(shProductForm)
    ) {
      const moq = currentVariantMeta.moq == false;
      if (moq) {
        btnTrigger.classList.remove("d-none");
        shProductForm.classList.remove("moq-message-active");
        moqMessage.classList.add("d-none");
      } else {
        btnTrigger.classList.add("d-none");
        shProductForm.classList.add("moq-message-active");
        moqMessage.classList.remove("d-none");
      }
    }
  };

  /*
   * Update the option text on variant change
   */
  const updateOptionText = () => {
    if (optionPriceText && optionTypeText && optionTextContainer) {

      const packPosition = productOptions.findIndex( option => option.name == 'Pack');
      const pack = currentVariant.options[packPosition];
      let price = currentVariant.price;
      const text = ( productData.type =='Item' || pack == "Case" ) ? "Case" : "Piece";
      if ( ( productData.type =='Item' || pack == "Case" ) && currentVariantMeta.case_quantity > 0) {
        price = currentVariant.price * currentVariantMeta.case_quantity;
      }     
      optionTextContainer.textContent = `${text}s`;
      optionPriceText.textContent = Shopify.formatMoney(price);
      optionTypeText.textContent = text;
    }
  };

  const updateDisplay = function () {
    /**
     * Initialize the product details page
     **/
    getCurrentVariantMeta();
    updateSku();
    updateItemPrice();
    updateVariantText();
    updateTotalItems();
    updateClosurePrice();
    toggleMoq();
    updateOptionText();
  };

  updateDisplay();

  const updateDisplayHandler = function($event) {
    currentVariant = $event.detail;
    updateDisplay();
  }

  const updateItemsHandler = function() {
    updateTotalItems();
  }

  eventBus.on(eventBus.types.OptionsSelected, updateDisplayHandler);

  /**
   * Do we need to wait for the page to be loaded?
   */
  // if (document.readyState !== 'loading') {
  //     updateTotalItems();
  // } else {
  //     document.addEventListener('DOMContentLoaded', updateTotalItems);
  // }

  eventBus.on(eventBus.types.QuantityUpdated, updateItemsHandler);
};

export default ProductDetails;